import useSimDetails from 'api/sims/useSimDetails';

const useIsEuiccSim = (hologramSimId?: HologramSimId) => {
  const { isLoading, error, simDetails } = useSimDetails(hologramSimId);

  const showEuiccInfo =
    !isLoading && !error && !!simDetails.simType && !simDetails.simCardId?.startsWith('UICC');

  return { showEuiccInfo, isLoading, error };
};

export default useIsEuiccSim;
